var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card mt-3", attrs: { "header-bg-variant": "white" } },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            this.getV1Type() === _vm.v1WIFI
              ? _c(
                  "h5",
                  { attrs: { "data-test-hook": "plan-cost-header-text" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xFuelMonitorWifiFree")) + " ")]
                )
              : this.getV1Type() === _vm.v1LTE
              ? _c(
                  "h5",
                  { attrs: { "data-test-hook": "plan-cost-header-text" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xFuelSupplierManaged")) + " ")]
                )
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { attrs: { "data-test-hook": "plan-cost-header-text" } },
              [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
            )
          ])
        ]),
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col" }, [
            this.getV1Type() === _vm.v1WIFI
              ? _c("strong", { attrs: { "data-test-hook": "plan-cost" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("xActive")) + " ")
                ])
              : this.getV1Type() === _vm.v1LTE
              ? _c("strong", { attrs: { "data-test-hook": "plan-cost" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.v1FuelMonitor.name) +
                      " " +
                      _vm._s(_vm.$t("xManagedByFuelSupplier")) +
                      " "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "accordion",
            staticStyle: { width: "100%" },
            attrs: { role: "tablist" }
          },
          [
            _c(
              "div",
              {
                staticClass: "accordion-wrapper",
                staticStyle: {
                  border: "1px solid lightgrey",
                  padding: "10px",
                  "border-radius": "10px"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle",
                        value:
                          "collapse-dealerManaged-" +
                          _vm.v1FuelMonitor.apparatusId,
                        expression:
                          "'collapse-dealerManaged-' + v1FuelMonitor.apparatusId"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row align-items-center no-gutters" },
                      [
                        _c("div", { staticClass: "col align-items-center" }, [
                          _c("i", {
                            staticClass: "fa-regular fa-circle-info pr-2"
                          }),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xProductsAndFeatures")))
                          ])
                        ]),
                        _vm._m(0)
                      ]
                    )
                  ]
                ),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id:
                        "collapse-dealerManaged-" +
                        _vm.v1FuelMonitor.apparatusId
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("hr", { staticClass: "mx-0 px-0" })
                      ])
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", { staticClass: "mb-0 pb-0" }, [
                          this.getV1Type() === _vm.v1WIFI
                            ? _c(
                                "strong",
                                {
                                  attrs: {
                                    "data-test-hook": "products-included-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xProductsIncludedInPlan")
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("xFuelMonitorWifiFree")) +
                                      " "
                                  )
                                ]
                              )
                            : this.getV1Type() === _vm.v1LTE
                            ? _c(
                                "strong",
                                {
                                  attrs: {
                                    "data-test-hook": "products-included-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xProductsIncludedInPlan")
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("xFuelSupplierManaged")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _c("i", { staticClass: "fa-kit fa-fw fa-tank" }),
                    _vm._v("  " + _vm._s(_vm.v1FuelMonitor.name) + " "),
                    _c("div", { staticClass: "row mt-3 mb-2" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", { staticClass: "mb-0 pb-0" }, [
                          this.getV1Type() === _vm.v1WIFI
                            ? _c(
                                "strong",
                                {
                                  attrs: {
                                    "data-test-hook": "features-included-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xFeaturesIncludedInPlan")
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("xFuelMonitorWifiFree")) +
                                      " "
                                  )
                                ]
                              )
                            : this.getV1Type() === _vm.v1LTE
                            ? _c(
                                "strong",
                                {
                                  attrs: {
                                    "data-test-hook": "features-included-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xFeaturesIncludedInPlan")
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("xFuelSupplierManaged")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col icon-and-text" }, [
                        _c("i", { staticClass: "fa-kit fa-fw fa-tank" }),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test-hook": "features-included-list"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "xSubFeaturesFmFuelLevelHistoryWarningsBattery"
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col icon-and-text" }, [
                        _c("i", { staticClass: "fal fa-check-circle" }),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test-hook": "features-included-list"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xSubFeaturesFmMonitorOneFm")) +
                                " "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", { staticClass: "fas fa-chevron-down when-closed" }),
      _c("i", { staticClass: "fas fa-chevron-up when-open" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }